import { useState } from 'react';
import { DownloadIcon } from 'icons';
import useDevice, { DEVICE_MOBILE } from 'hooks/use-device';
import LightBox from 'componets/light-box';
import { getAuth } from 'service/local-data-provider';
import styles from './download-license-plate-button.module.sass';
import { endPoint } from 'config/config';
import analytics from 'service/analytics';

const END_POINT = `${endPoint}/v3/enterprise/download_vehicle_informations`;

export const DownloadLicensePlateButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const device = useDevice();
  const isMobile = device === DEVICE_MOBILE;

  const downloadFile = async () => {
    if (isLoading) return;

    setIsLoading(true);
    const accessToken = getAuth()?.accessToken;

    const data = await fetch(END_POINT, {
      headers: { Authorization: 'Bearer ' + accessToken },
    });

    const blob = await data.blob();

    window.URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = window.URL.createObjectURL(blob);

    link.download = '車籍資料.xlsx';

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
    setIsLoading(false);
    setIsOpen(false);
  };

  const handleClick = () => {
    analytics.licensePlatesDownloadButtonClick();
    setIsOpen(true);
  };

  return (
    <>
      <button className={styles['download-license-plates-button']} onClick={handleClick}>
        <div className={styles['download-license-plates-button-container']}>
          <DownloadIcon width={20} height={20} />
          {!isMobile && <p>下載全部車牌</p>}
        </div>
      </button>
      <LightBox
        show={isOpen}
        loading={isLoading}
        title="下載全部車牌"
        content="確認是否要下載全部的付款車牌。"
        approveText="下載"
        onCancel={() => setIsOpen(false)}
        onApprove={downloadFile}
      />
    </>
  );
};
